// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_3VkYN-R3f6sjoi3EZnJObW","block":"_3MlMDg4hHgpZFfdboM-ZcF","blockName":"_3Co9_QuDQG9-ORMNXmFGTa","blockValue":"_3XC8PDWjm7TbBTVr6SNK1U"};